import { useLocales } from "@/react/story/providers/LocalesContext";
import { DEFAULTS } from "@/react/story/data";
import type { Content } from "@/react/story/types";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";

type Props = {
    content: Content;
}

export default function ContentOrigin(props: Props) {
    const Locales = useLocales();
    const identifier = props.content.config.identifier;

    return (
        <img
            src={`/origins/${identifier}/vertical.png?locale=${Locales.current}`}
            style={{
                maxWidth: TemplatingUtils.percent(DEFAULTS.maxWidth),
                ...TemplatingUtils.style(props.content.config, [ "maxWidth", "borderRadius" ]),
            }}
            alt={identifier}
        />
    );
}
